import { cn } from '~/lib/utils';
import gmailIcon from '~/landing_page/Assets/Gmail.png';
import styles from './WidgetCard.module.css';

export interface GmailCardProps {
  className?: string;
  subject?: string;
  time?: string;
  body?: string;
}

export const GmailCard = ({
  className,
  subject = 'Re: Sprint 34 deck',
  time = '1:00 PM',
  body = 'Can you add the velocity chart? The carry-over tickets also need a bit more context for the PMs.',
}: GmailCardProps) => {
  return (
    <div className={cn(styles.card, className)} style={{ height: 90 }}>
      <div className={styles.row}>
        <img src={gmailIcon} className={styles.icon} alt="Gmail" />
        <div className={cn(styles.container, styles.containerSmallGap)}>
          <div className={styles.header}>
            <span className={styles.headerTitle}>{subject}</span>
            <span className={styles.headerMeta}>{time}</span>
          </div>
          <p className={styles.text}>{body}</p>
        </div>
      </div>
    </div>
  );
};

GmailCard.displayName = 'GmailCard';
